import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { EventListType } from '@diritto/common/event/constants';
import { EventParticipatedResponseDto } from '@diritto/common/event/dtos/event-participated.dto';
import { EventResponseDto, EventsResponseDto } from '@diritto/common/event/dtos/event.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { generateUrl } from '@diritto/common/utils/urls';
import { AxiosRequestConfig } from 'axios';

export interface GetEventsQuery {
  listType: EventListType;
}

export class EventApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getEvents(params: BasePaginatorDto & GetEventsQuery, options?: AxiosRequestConfig) {
    const res = await this.http.get<EventsResponseDto>(`${this.url}/events`, {
      params,
      ...options,
    });
    return res.data;
  }

  async getEvent(eventId: number, ignoreAccessible: boolean, options?: AxiosRequestConfig) {
    const res = await this.http.get<EventResponseDto>(
      generateUrl(`${this.url}/events/${eventId}`, ignoreAccessible ? { ignoreAccessible } : {}),
      options,
    );
    return res.data;
  }

  async getContentEvents(contentId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<EventsResponseDto>(`${this.url}/contents/${contentId}/events`, {
      ...options,
    });
    return res.data;
  }

  async getEventParticipated(eventId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<EventParticipatedResponseDto>(`${this.url}/events/${eventId}/participate`, options);
    return res.data;
  }

  async participateEvent(eventId: number, options?: AxiosRequestConfig) {
    const res = await this.http.post<undefined, ResponseDto>(
      `${this.url}/events/${eventId}/participate`,
      undefined,
      options,
    );
    return res.data;
  }
}
